define('views/pages/NotFoundPageView',['underscore','jquery','PageView','router', 'app', 'canvasVideo'
],function(_,$,PageView,router, app, CanvasVideo){

    return PageView.extend({
        pageName:'NotFound',
        events: {

        },
        initialize:function(){

            var self = this;
            // PageView constructor heritage
            PageView.prototype.initialize.apply(self,arguments);

            if(self.getVideo() && app.isMobile()){
                self.video = new CanvasVideo(self.getVideo(), {
                    audio: false,
                    autoplay: true,
                    audioBuffer: false,
                    loop: true,
                    fps: 24
                });
                self.$('.canvas-container').prepend(self.video.element);
            }else{
                self.$('.page-404').prepend('<video autoload autoplay loop muted>'
                    + '<source src="'+ self.getVideo() +'" type="video/mp4">'
                    + '</video>');
            }

        },

        remove:function () {
            if(this.video){
                this.video.destroy();
                delete this.video;
            }
            PageView.prototype.remove.apply(this);
        },

        getVideo: function(){
        // return THEME_URL + '/medias/videos/404.mp4';
            return app.c('_404_ULR_VIDEO_');
        }





    });

});
